module.exports = __webpack_public_path__ + "img/patient-card-tabs-desktop-fr.6ae7d800.jpg";